/*
Purpose: list of Student Year Level (Super Admin) - separate master from Activity Year Level.
No subject involved - only Country + Year Level Name.
Project: TCMS
*/

import React from 'react';
import { useState, useEffect, useRef } from "react";
import { NavLink } from 'react-router-dom';

import { Row, Col, Card, Form, Modal, Button } from 'react-bootstrap';
import axios from 'axios';

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';

import Select from 'react-select';
import { useFormik } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { security_key, options_countries, BASE_URL } from "../global";

import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { Button as Buttonmui } from '@mui/material';

const StudentYearLevelList = () => {

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.post(BASE_URL + 'API/api_index.php', {
        security_key: security_key,
        mode: "getAllCountryStudentYearLevel"
      });

      if (response.data.success === true) {
        setRecords(response.data.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  // Sample columns configuration
  const columns = [
    {
      headerName: 'Countries',
      field: "Country",
      headerClassName: "super-app-theme--header",
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.country_name != null && params.row.country_name != '' ? params.row.country_name : '-'}`;
      },
    },
    {
      headerName: 'Year Level',
      field: "YearLevel",
      headerClassName: "super-app-theme--header",
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.level_name != null && params.row.level_name != '' ? params.row.level_name : '-'}`;
      },
    },
    {
      headerName: 'Abbreviation',
      field: "Abbreviation",
      headerClassName: "super-app-theme--header",
      flex: 1,
      valueGetter: (params) => {
        const row = params.row;
        const words = row.level_name.split(/(\d+)/).filter(Boolean).map((element, index) => index === 0 ? element.charAt(0) : element);
        const abbreviation = words.map((word, index) => (index === 0 ? word.charAt(0).toUpperCase() : word)).join('');
        if (abbreviation) {
          return abbreviation;
        } else {
          return words;
        }
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      width: 150,
      disableExport: false,
      disableColumnFilter: false,
      disableColumnMenu: false,
      filterable: true,
      sortable: true,
      headerAlign: "left",
      valueGetter: (params) => {
        return `${parseInt(params.row.is_deleted) === 1 ? 'Deactive' : 'Active'}`;
      },
      renderCell: (params) => {
        const row = params.row;

        return (
          <div className='d-flex justify-content-center align-items-center'>
            <Buttonmui variant="outlined-red"  onClick={() => handleEditClick(row)}  className="primary-blue  btnmr-2 my-auto" >
            <EditIcon className="btn-icon me-1"/> Edit
           </Buttonmui>
            {/* <span className='cursor-pointer' onClick={() => handleEditClick(row)}>
              <EditIcon className="btn-icon" />
            </span> */}

            {parseInt(row.is_deleted) === 1 ? (
              <span className='cursor-pointer deactive-btn' onClick={() => handleActivateClick(row)}>
                <CloseIcon className="btn-icon me-1" />
                Deactive
              </span>
            ) : (
              <span className='cursor-pointer active-btn' onClick={() => handleDeactivateClick(row)}>
                <DoneIcon className="icon-blue btn-icon me-1" />
                Active
              </span>
            )}
          </div>
        );
      },
    },
  ];

  const [modalShowAdd, setModalShowAdd] = useState(false);

  const basicSchema = yup.object().shape({
    syl_country: yup.mixed().required("Country is required."),
    syl_name: yup.string().min(2, "Minimum 2 characters is required.").required("Year Level is required.")
      .matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma")
      .matches(/^[^'"\\]*(?:[^'"\\][^'"\\]*)*$/, "Avoid apostrophe & quotes."),
  });

  const initialValues = {
    /* tbl_stu_year_level */
    syl_country: "",
    syl_name: '',
    created_by: sessionStorage.getItem('key'),
  };

  const formik = useFormik({
    initialValues,
    validationSchema: basicSchema,
    enableReinitialize: true,
    onSubmit: async (formValues) => {
      setIsSubmitting(true);

      try {
        const response = await axios.post(BASE_URL + "API/api_index.php", {
          security_key: security_key,
          mode: "createStudentYearLevel",
          ...formValues,
        });

        if (response.data.success === true) {
          if (response.data.data == 1) {
            toast.success("Success! Student Year Level has been created", {
              autoClose: 2000,
            });
            fetchData();
            setModalShowAdd(false);
            resetForm();
            setIsSubmitting(false);
          } else if (response.data.data == 2) {
            toast.error("Student year level already exists for this country", {
              autoClose: 3000,
            });
            setIsSubmitting(false);
          } else {
            toast.error("Failure! Unable to create student year level. Try again later", {
              autoClose: 3000,
            });
            setIsSubmitting(false);
          }
        } else {
          toast.error("Failure! Unable to create student year level. Try again later", {
            autoClose: 3000,
          });
          setIsSubmitting(false);
        }
      } catch (error) {
        toast.error("Failure! Unable to create student year level. Try again later", {
          autoClose: 3000,
        });
        setIsSubmitting(false);
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  const values = formik.values;
  const handleBlur = formik.handleBlur;
  const touched = formik.touched;
  const handleChange = formik.handleChange;
  const errors = formik.errors;
  const handleSubmit = formik.handleSubmit;
  const setTouched = formik.setTouched;
  const resetForm = formik.resetForm;



  const [modalShowEdit, setModalShowEdit] = useState(false);

const editSchema = yup.object().shape({
  syl_country: yup.mixed().required("Country is required."),
  syl_name: yup.string().min(2, "Minimum 2 characters is required.").required("Year Level is required.")
    .matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma")
    .matches(/^[^'"\\]*(?:[^'"\\][^'"\\]*)*$/, "Avoid apostrophe & quotes."),
});

const editInitialValues = {
  pk_stu_year_level_id: '',
  syl_country: "",
  syl_name: '',
  updated_by: sessionStorage.getItem('key'),
};

const [isEditSubmitting, setIsEditSubmitting] = useState(false);
const editFormRef = useRef(null);

const editFormik = useFormik({
  initialValues: editInitialValues,
  validationSchema: editSchema,
  enableReinitialize: true,
  onSubmit: async (formValues) => {
    setIsEditSubmitting(true);

    try {
      const response = await axios.post(BASE_URL + "API/api_index.php", {
        security_key: security_key,
        mode: "updateStudentYearLevel",
        ...formValues,
      });

      if (response.data.success === true) {
        if (response.data.data == 1) {
          toast.success("Success! Student Year Level has been updated", {
            autoClose: 2000,
          });
          fetchData();
          setModalShowEdit(false);
          editResetForm();
        } else if (response.data.data == 2) {
          toast.error("Student year level already exists for this country", {
            autoClose: 3000,
          });
        } else {
          toast.error("Failure! Unable to update student year level. Try again later", {
            autoClose: 3000,
          });
        }
      } else {
        toast.error("Failure! Unable to update student year level. Try again later", {
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error("Failure! Unable to update student year level. Try again later", {
        autoClose: 3000,
      });
    } finally {
      setIsEditSubmitting(false);
    }
  },
});

const editValues = editFormik.values;
const editHandleBlur = editFormik.handleBlur;
const editTouched = editFormik.touched;
const editHandleChange = editFormik.handleChange;
const editErrors = editFormik.errors;
const editHandleSubmit = editFormik.handleSubmit;
const editSetTouched = editFormik.setTouched;
const editResetForm = editFormik.resetForm;
const editSetValues = editFormik.setValues;

const handleEditClick = (row) => {
  const matchedCountry = options_countries.find(
    (opt) => opt.value == row.country_id
  );

  editSetValues({
    pk_stu_year_level_id: row.pk_stu_year_level_id,
    syl_country: matchedCountry?.value || "",
    syl_name: row.level_name,
    updated_by: sessionStorage.getItem('key'),
  });
  setModalShowEdit(true);
};

  const [showDeactivate, setDeactivateShow] = useState(false);
  const [data_deactivate, setDeactivateLabelData] = useState([]);
  const [isDeactivateSubmitting, setIsDeactivateSubmitting] = useState(false);

  const handleDeactivateClick = (row) => {
    setDeactivateLabelData({ ...row });
    setDeactivateShow(true);
  };

  const [showActivate, setActivateShow] = useState(false);
  const [data_activate, setActivateLabelData] = useState([]);
  const [isActivateSubmitting, setIsActivateSubmitting] = useState(false);

  const handleActivateClick = (row) => {
    setActivateLabelData({ ...row });
    setActivateShow(true);
  };

  function onSubmitDeactivate() {
    setIsDeactivateSubmitting(true);

    axios.post(BASE_URL + "API/api_index.php", {
      security_key: security_key,
      updated_by: sessionStorage.getItem('key'),
      mode: "deactivateStudentYearLevel",
      pk_stu_year_level_id: data_deactivate.pk_stu_year_level_id
    }).then((response) => {
      if (response.data.data == 1) {
        setDeactivateShow(false);
        toast.success("Success! Student year level has been deactivated.", {
          autoClose: 3000,
        });
        fetchData();
      } else {
        toast.error("Failure! Unable to deactivate student year level. Try again later", {
          autoClose: 3000,
        });
      }
      setIsDeactivateSubmitting(false);
    }).catch((error) => {
      toast.error("Failure! Unable to deactivate student year level. Try again later", {
        autoClose: 3000,
      });
      setIsDeactivateSubmitting(false);
    });
  }

  function onSubmitActivate() {
    setIsActivateSubmitting(true);

    axios.post(BASE_URL + "API/api_index.php", {
      security_key: security_key,
      updated_by: sessionStorage.getItem('key'),
      mode: "activateStudentYearLevel",
      pk_stu_year_level_id: data_activate.pk_stu_year_level_id
    }).then((response) => {
      if (response.data.data == 1) {
        setActivateShow(false);
        toast.success("Success! Student year level has been activated.", {
          autoClose: 3000,
        });
        fetchData();
      } else {
        toast.error("Failure! Unable to activate student year level. Try again later", {
          autoClose: 3000,
        });
      }
      setIsActivateSubmitting(false);
    }).catch((error) => {
      toast.error("Failure! Unable to activate student year level. Try again later", {
        autoClose: 3000,
      });
      setIsActivateSubmitting(false);
    });
  }

  return (
    <>
      <ToastContainer position="top-center" />

      <Modal show={showDeactivate} variant="danger">
        <Modal.Header>Student Year Level</Modal.Header>
        <Modal.Body>
          <p>Are you sure? You want to deactivate this student year level?</p>
        </Modal.Body>
        <Modal.Footer className='pt-0'>
          <div className="mx-auto d-flex gap-2">
            <Button variant="contained" className="primary-gray" onClick={() => setDeactivateShow(false)}>Cancel</Button>
            <Button variant="contained" type='submit' className="primary-filled" disabled={isDeactivateSubmitting} onClick={() => onSubmitDeactivate()}>Yes</Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={showActivate} variant="danger">
        <Modal.Header>Student Year Level</Modal.Header>
        <Modal.Body>
          <p>Are you sure? You want to activate this student year level?</p>
        </Modal.Body>
        <Modal.Footer className='pt-0'>
          <div className="mx-auto d-flex gap-2">
            <Button variant="contained" className="primary-gray" onClick={() => setActivateShow(false)}>Cancel</Button>
            <Button variant="contained" type='submit' className="primary-filled" disabled={isActivateSubmitting} onClick={() => onSubmitActivate()}>Yes</Button>
          </div>
        </Modal.Footer>
      </Modal>

      <div className="page-wrapper">

        <Modal
          show={modalShowAdd} onHide={() => setModalShowAdd(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          className='small-modal'
          centered
        >
          <Form autoComplete="off" onSubmit={handleSubmit} ref={formRef}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                <h5 className='page-title'>Add Student Year Level</h5>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Row>
                <Col lg="12" md="12" sm="12" className='position-relative mb-3'>
                  <h6 className="form-label required-field">Countries</h6>
                  <Select menuPlacement="auto"
                    options={options_countries}
                    name="syl_country"
                    value={values.syl_country['value']}
                    id="syl_country"
                    onChange={async (selectedOption) => {
                      const event = {
                        target: {
                          name: "syl_country",
                          value: selectedOption["value"],
                        },
                      };
                      handleChange(event);
                    }}
                    onBlur={(event) => {
                      handleBlur(event);
                      setTouched({ ...touched, syl_country: true });
                    }}
                    className={errors.syl_country && touched.syl_country ? "input-error" : ""}
                  />
                  {errors.syl_country && touched.syl_country && <span className="error">{errors.syl_country}</span>}
                </Col>

                <Col lg="12" md="12" sm="12" className='position-relative'>
                  <h6 className="form-lable required-field">Year Level</h6>
                  <Form.Control
                    type='text'
                    value={values.syl_name}
                    id="syl_name"
                    name="syl_name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={errors.syl_name && touched.syl_name ? "input-error mb-0" : "mb-0"}
                  />
                  {errors.syl_name && touched.syl_name && <span className="error">{errors.syl_name}</span>}
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer>
              <div className="mx-auto d-flex gap-2">
                <Button variant="contained" className="primary-gray" onClick={() => setModalShowAdd(false)}>Cancel</Button>
                <Button variant="contained" type='submit' className="primary-filled" disabled={isSubmitting}>Save</Button>
              </div>
            </Modal.Footer>
          </Form>
        </Modal>

        <Modal
          show={modalShowEdit} onHide={() => setModalShowEdit(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          className='small-modal'
          centered
        >
          <Form autoComplete="off" onSubmit={editHandleSubmit} ref={editFormRef}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                <h5 className='page-title'>Edit Student Year Level</h5>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Row>
                <Col lg="12" md="12" sm="12" className='position-relative mb-3'>
                  <h6 className="form-label required-field">Countries</h6>
                  <Select menuPlacement="auto"
                    options={options_countries}
                    name="syl_country"
                    value={options_countries.find(option => option.value && editValues.syl_country && option.value == editValues.syl_country)}
                    // value={editValues.syl_country['value']}
                    id="syl_country"
                    onChange={async (selectedOption) => {
                      const event = {
                        target: {
                          name: "syl_country",
                          value: selectedOption["value"],
                        },
                      };
                      editHandleChange(event);
                    }}
                    onBlur={(event) => {
                      editHandleBlur(event);
                      editSetTouched({ ...editTouched, syl_country: true });
                    }}
                    className={editErrors.syl_country && editTouched.syl_country ? "input-error" : ""}
                  />
                  {editErrors.syl_country && editTouched.syl_country && <span className="error">{editErrors.syl_country}</span>}
                </Col>

                <Col lg="12" md="12" sm="12" className='position-relative'>
                  <h6 className="form-lable required-field">Year Level</h6>
                  <Form.Control
                    type='text'
                    value={editValues.syl_name}
                    id="syl_name"
                    name="syl_name"
                    onChange={editHandleChange}
                    onBlur={editHandleBlur}
                    className={editErrors.syl_name && editTouched.syl_name ? "input-error mb-0" : "mb-0"}
                  />
                  {editErrors.syl_name && editTouched.syl_name && <span className="error">{editErrors.syl_name}</span>}
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer>
              <div className="mx-auto d-flex gap-2">
                <Button variant="contained" className="primary-gray" onClick={() => setModalShowEdit(false)}>Cancel</Button>
                <Button variant="contained" type='submit' className="primary-filled" disabled={isEditSubmitting}>Save</Button>
              </div>
            </Modal.Footer>
          </Form>
        </Modal>

        {/* --------------Page Start--------------- */}

          <Card.Body>
            <div className='mb-3 d-flex justify-content-end align-items-center year-level-btn'>
              <div>
                <Button variant="contained" className="primary-filled rounded-10 p-2" onClick={() => setModalShowAdd(true)}>
                  <AddIcon className="btn-icon me-2" />
                  Add Student Year Level
                </Button>
              </div>
            </div>
            <Row>
              <Col sm={12}>
                <Box
                  sx={{
                    height: "fit-content",
                    width: "100%",
                    "& .actions": { color: "text.secondary" },
                    "& .textPrimary": { color: "text.primary" },
                    "& .super-app-theme--header": { backgroundColor: "#f4f4f4" },
                  }}
                  style={{ height: '100%', width: "100%" }}
                >
                  <DataGrid
                    sx={{
                      '.MuiDataGrid-cell:focus': { outline: 'none' },
                      '& .MuiDataGrid-row:hover': { cursor: 'pointer' }
                    }}
                    autoHeight
                    loading={loading}
                    slots={{
                      loadingOverlay: LinearProgress,
                      toolbar: GridToolbar,
                    }}
                    slotProps={{
                      toolbar: {
                        csvOptions: { fileName: "StudentYearLevelList" },
                        printOptions: {
                          pageStyle: `@media print {
                          @page {
                            size: A4 landscape;
                            margin: 0;
                          }
                        }`, disableToolbarButton: true, hideFooter: true, hideToolbar: true, fileName: "StudentYearLevelList"
                        },
                        records,
                        showQuickFilter: true
                      },
                    }}
                    initialState={{
                      ...records.initialState,
                      pagination: { paginationModel: { pageSize: 10 } },
                    }}
                    pageSizeOptions={[10, 25, 50, 100]}
                    rows={records.map((row, index) => ({ ...row, id: `row-${index}` }))}
                    columns={columns}
                    rowHeight={60} density="compact"
                    disableRowSelectionOnClick
                    showCellVerticalBorder={true}
                    showColumnVerticalBorder={true}
                  />
                </Box>
              </Col>
            </Row>
          </Card.Body>

        {/* --------------Page End--------------- */}

      </div>
    </>
  );
};

export default StudentYearLevelList;